module.exports = __webpack_public_path__ + "static/media/tankTrailer_purple.814114f6.svg";